var _defs, _path, _rect, _path2, _path3, _rect2, _rect3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect6, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 568.75 597.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 553.74,
    x2: 550.45,
    y1: -190.33,
    y2: 478.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 476.06,
    x2: 719.78,
    y1: 421.96,
    y2: 421.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 431.96,
    x2: 485.43,
    y1: 164.76,
    y2: 164.76,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 427.04,
    x2: 486.91,
    y1: 213.64,
    y2: 213.64,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 429.73,
    x2: 474.91,
    y1: 270.72,
    y2: 270.72,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 433.7,
    x2: 480.26,
    y1: 328.6,
    y2: 328.6,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 393.86,
    x2: 441.19,
    y1: 157.7,
    y2: 155.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 395.9,
    x2: 443.23,
    y1: 208.7,
    y2: 206.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 398.19,
    x2: 445.51,
    y1: 265.75,
    y2: 263.86,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 400.51,
    x2: 447.84,
    y1: 323.92,
    y2: 322.02,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 287.15,
    x2: 335.77,
    y1: 232.36,
    y2: 315.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 307.56,
    x2: 318.35,
    y1: 60.33,
    y2: 108.87,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 300.63,
    x2: 311.42,
    y1: 61.87,
    y2: 110.41,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 293.7,
    x2: 304.49,
    y1: 63.41,
    y2: 111.95,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 97.37,
    x2: 97.72,
    y1: 236.2,
    y2: 236.2,
    xlinkHref: "#c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M465.62.29C403.1,5.44,364.54,70.89,308.29,98.68c-25.27,12.49-53.74,17.07-79.66,28.14-44.09,18.82-81.29,62.37-77.31,110.14,5.16,61.92,71.94,100.37,92.93,158.84,5.79,16.14,7.91,33.42,13.88,49.48,14.9,40.09,55.28,69.34,98,71,34.31,1.33,67.05-13.42,101-18.62,41.56-6.38,83.93,1.69,126,.26s88-15.73,108.63-52.37c16.7-29.67,12.62-66.63,3.38-99.4S671.87,281.4,670,247.4c-2.16-39.59,10.69-85.2-15.45-115C635.15,110.23,599.32,105,585.48,79c-14.94-28-20.18-31.73-45.3-48.33C515.34,14.22,498.37-2.41,465.62.29Z",
    opacity: 0.18,
    transform: "translate(-151.03)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195.33,
    height: 371.63,
    x: 302.92,
    y: 57.78,
    fill: "#68e1fd",
    rx: 22.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M641.25,85.66V398.14a20.67,20.67,0,0,1-20.67,20.66H482.65A20.67,20.67,0,0,1,462,398.14V85.67A20.68,20.68,0,0,1,482.66,65h21v1.63a11.63,11.63,0,0,0,11.63,11.63h71.58a11.62,11.62,0,0,0,11.63-11.63V65h22.09A20.68,20.68,0,0,1,641.25,85.66Z",
    transform: "translate(-151.03)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M641.25,85.66V398.14a20.67,20.67,0,0,1-20.67,20.66H482.65A20.67,20.67,0,0,1,462,398.14V85.67A20.68,20.68,0,0,1,482.66,65h21v1.63a11.63,11.63,0,0,0,11.63,11.63h71.58a11.62,11.62,0,0,0,11.63-11.63V65h22.09A20.68,20.68,0,0,1,641.25,85.66Z",
    opacity: 0.81,
    transform: "translate(-151.03)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 131.76,
    height: 47.72,
    x: 340.67,
    y: 264.77,
    fill: "#fff",
    opacity: 0.17,
    rx: 10.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 131.76,
    height: 47.72,
    x: 340.67,
    y: 331.91,
    fill: "#fff",
    opacity: 0.17,
    rx: 10.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M675.18,291.94l-47.25-45.28s-17.2,13.62-9.86,38.27,31.21,54.32,31.21,54.32v68s.27,22.12-22.12,22.12H476.06s13.18,34.7,40,64.16S591,559.38,588.94,597.26H719.78s-33.52-119.31-22-167.85S705,320.49,675.18,291.94Z",
    transform: "translate(-151.03)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M475.18,198.89c-4.78-1.17-16.76-9.43-26.52-18.26-6.2-5.6-11.51-11.43-13.52-15.83-5.18-11.32-6.09-36.11,13.52-34.21,0,0,8-1.82,26.52,25.79S483,200.81,475.18,198.89Z",
    transform: "translate(-151.03)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M479,244.92c-5-.3-19-6.63-30.37-13.82-6.68-4.22-12.5-8.74-15.14-12.52-7.14-10.2-12.49-34.42,7.15-36.07,0,0,2.22-1,8,2,4.83,2.49,12.14,7.72,22.73,18.59C494.58,226.93,487.06,245.4,479,244.92Z",
    transform: "translate(-151.03)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M466.82,304.82c-3.32-.9-10.91-6.65-18.16-13.57-7-6.65-13.61-14.38-15.86-19.91-4.6-11.3-6-36.27,10.26-34.78,0,0,1.73-.53,5.6,2.68,3.65,3,9.21,9.4,17,22.72C481.73,289.39,473.32,306.57,466.82,304.82Z",
    transform: "translate(-151.03)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M474.28,354.47c-4.21-.32-16.45-6.48-25.62-13.06-4.32-3.1-8-6.29-9.77-9-5.6-8.45-10-28.4,5.19-29.57,0,0,1.29-.58,4.58.91,3.65,1.65,9.78,5.87,19.33,16.3C486.11,339.84,480.48,354.94,474.28,354.47Z",
    transform: "translate(-151.03)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 131.76,
    height: 47.72,
    x: 340.67,
    y: 130.49,
    fill: "#fff",
    opacity: 0.17,
    rx: 10.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 131.76,
    height: 47.72,
    x: 340.67,
    y: 197.63,
    fill: "#fff",
    opacity: 0.17,
    rx: 10.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M448.66,130.59v50c-6.2-5.6-11.51-11.43-13.52-15.83C430,153.48,429.05,128.69,448.66,130.59Z",
    opacity: 0.81,
    transform: "translate(-151.03)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M448.66,184.5v46.6c-6.68-4.22-12.5-8.74-15.14-12.52-7.14-10.2-12.49-34.42,7.15-36.07C440.67,182.51,442.89,181.55,448.66,184.5Z",
    opacity: 0.81,
    transform: "translate(-151.03)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M448.66,239.24v52c-7-6.65-13.61-14.38-15.86-19.91-4.6-11.3-6-36.27,10.26-34.78C443.06,236.56,444.79,236,448.66,239.24Z",
    opacity: 0.81,
    transform: "translate(-151.03)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M448.66,303.75v37.66c-4.32-3.1-8-6.29-9.77-9-5.6-8.45-10-28.4,5.19-29.57C444.08,302.84,445.37,302.26,448.66,303.75Z",
    opacity: 0.81,
    transform: "translate(-151.03)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M433.7,38V425.33a22.09,22.09,0,0,1-22.09,22.1H227.79a22.09,22.09,0,0,1-22.09-22.1V38A22.09,22.09,0,0,1,227.79,15.9H411.61A22.09,22.09,0,0,1,433.7,38Z",
    transform: "translate(-151.03)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M262.08,15.9V447.43H227.79a22.09,22.09,0,0,1-22.09-22.1V38A22.09,22.09,0,0,1,227.79,15.9Z",
    opacity: 0.17,
    transform: "translate(-151.03)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M399.29,219.61v69.82a11.21,11.21,0,0,1-11.21,11.21H205.7V208.41H388.08A11.2,11.2,0,0,1,399.29,219.61Z",
    opacity: 0.19,
    transform: "translate(-151.03)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 233.8,
    height: 92.24,
    x: 2.33,
    y: 191.6,
    fill: "#68e1fd",
    rx: 11.21
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M389.29,106H243.77a5.33,5.33,0,0,1-5.33-5.32h0a5.33,5.33,0,0,1,5.33-5.33H389.29a5.33,5.33,0,0,1,5.33,5.33h0A5.32,5.32,0,0,1,389.29,106Z",
    opacity: 0.19,
    transform: "translate(-151.03)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M389.29,138.74H243.77a5.33,5.33,0,0,1-5.33-5.33h0a5.33,5.33,0,0,1,5.33-5.32H389.29a5.32,5.32,0,0,1,5.33,5.32h0A5.33,5.33,0,0,1,389.29,138.74Z",
    opacity: 0.19,
    transform: "translate(-151.03)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M389.29,171.46H243.77a5.33,5.33,0,0,1-5.33-5.32h0a5.33,5.33,0,0,1,5.33-5.33H389.29a5.33,5.33,0,0,1,5.33,5.33h0A5.32,5.32,0,0,1,389.29,171.46Z",
    opacity: 0.19,
    transform: "translate(-151.03)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M223.56,215v42.47a8.23,8.23,0,0,1-7.88,8.22,2.17,2.17,0,0,1-.36,0H172.85a8.24,8.24,0,0,1-8.24-8.24V215a8.23,8.23,0,0,1,8.24-8.23h42.47A8.23,8.23,0,0,1,223.56,215Z",
    opacity: 0.19,
    transform: "translate(-151.03)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M216.62,259.24a22.23,22.23,0,0,1-.94,6.41,2.17,2.17,0,0,1-.36,0H173.13a22.26,22.26,0,0,1,14.1-27.46,12.06,12.06,0,1,1,12.68-.5A22.22,22.22,0,0,1,216.62,259.24Z",
    opacity: 0.17,
    transform: "translate(-151.03)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.6b912055818ed83dac3e02b14b1c1c65.svg";
export { ForwardRef as ReactComponent };